export default __webpack_public_path__ + "static/media/gamefi_02_1.230ef3a3.png";